import useFeature from '~/client/hooks/feature/useFeature';
import FormRegister from './FormRegister';
import FormRegisterFastSignup from './FormRegisterFastSignup';
import RegisterWrapper from './RegisterFormWrapper';

type Props = {
  handleSuccess?: () => void;
  isPopover?: boolean;
};

const RegisterBody: FC<Props> = ({ handleSuccess, isPopover = false }) => {
  const showSignUpSocialAuth = useFeature('signUpSocialAuth');
  const isFastSignUpEnabled = useFeature('isFastSignUpEnabled');

  if (isFastSignUpEnabled) {
    return (
      <RegisterWrapper
        translateId="profile.signup_with_email-heading"
        showSignUpSocialAuth={showSignUpSocialAuth}
      >
        <FormRegisterFastSignup
          onSuccess={handleSuccess}
          isPopover={isPopover}
        />
      </RegisterWrapper>
    );
  }
  return (
    <RegisterWrapper
      translateId="profile.signup"
      showSignUpSocialAuth={showSignUpSocialAuth}
    >
      <FormRegister onSubmitHandle={handleSuccess} isPopover={isPopover} />
    </RegisterWrapper>
  );
};

export default RegisterBody;
